<template>

    <div class="location-picker-2023" :class="{'-default': !isInlineStyled, '-inline': isInlineStyled}">

        <div class="picker-title">

            <template v-if="!disableLocationSelections">
                {{resxTitle}}
            </template>
            <template v-else>
                <!--[Geselecteerde locatie(s)]-->

            </template>

        </div>
        <template v-for="(loc,index) in filterSelectionLocation.selection">
            <input v-if="loc.hasSelection()" type="hidden" :name="'Locations['+index+']'" :value="loc.getAsFormValue()" />
        </template>

        <!--<input id="location_search_input" />-->

        <div class="countries-container" v-if="!disableLocationSelections">

            <country-component v-for="country in countries"
                               :key="country.id"
                               :country="country"
                               :is-toggled="toggledCountries.has(country.id)"
                               @toggle="onToggleCountry"
                               @select="onSelectCountry"
                               @select-region="onSelectRegion"></country-component>


        </div>
        <div class="countries-container " v-else>

            <div v-for="(country) in currentReadOnlySelection" class="country-component -open -read-only">

                <div class="country-label">

                  
                    <img v-if="country.iconUrl" class="image" :src="country.iconUrl"  />
                    <i v-else class="no-image fal fa-map-marker-alt" ></i>
                    <div class="name">{{country.label}}</div>

                </div>

                <div class="regions-container">
                   
                    <div v-for="(region) in country.subEntries" class="region-component -selected -read-only">

                        <span  class="selected-component">
                         
                            <i class="fal fa-check-circle"></i>
                        </span>

                        <div class="name">{{region.label}}</div>


                    </div>

                </div>

            </div>


        </div>

        <div class="action-buttons">
            <button type="button" class="btn "
                    :class="{'btn-secondary': !isInlineStyled, 'btn-outline-dark': isInlineStyled}"
                    @click="onSelectNoPreference">
                {{noPreferenceButtonLabel}}
            </button>
            <button type="button" v-if="!hideConfirmButton" class="btn btn-primary confirm-action" :class="{'has-selection': hasSelection}" @click="locationConfirmed">{{resxConfirmButton}}</button>
        </div>
        <div class="loading-indicator" v-if="false">

            <span id="location-container-suspense-loader">
                <i class="fal fa-3x fa-spinner fa-spin"></i>
            </span>
        </div>
    </div>
</template>

<script src="./LocationPicker2023.ts"></script>
<style src="./styles2023.css"></style>